export default __webpack_public_path__ + "static/media/scala.d75aebd6.png";